import {StaticImageData} from 'next/image'
import {IS_SERVER} from '@/constants/env'
import getUaParam from '@/utils/getUaParam'
import gaotuLogoImg from '@/public/img/logo/gaotuLogo.png'
import gongkaoLogoImg from '@/public/img/logo/gongkaoLogo.png'
import tutuLogoImg from '@/public/img/logo/tutuLogo.png'
import jingpinLogoImg from '@/public/img/logo/jingpinLogo.png'
import xinliLogoImg from '@/public/img/logo/xinliLogo.png'
import ketangLogoImg from '@/public/img/logo/ketangLogo.png'
import defaultAvatarImg from '@/public/img/defaultAvatar.png'
import defaultAvatarTutuImg from '@/public/img/defaultAvatarTutu.png'

export type IBizType = 1 | 6 | 2 | 3 | 8 | 18;

// app的配置信息
export interface IAppConfig {
    scheme: string;
    packageName: string;
    universalHost: string;
    fallback?: string;
    appstore?: string;
    appstoreScheme: string;
    ckey?: string;
    logo: StaticImageData;
    cnName: string;
    bizType: IBizType;
    defaultUserName: string;
    defaultUserAvatar: StaticImageData;
    payHost?: string;
    mHaboBizName?: string,
    appHaboBizName?:string
}
export const APP_NAME_MAP: Record<string, AppName> = {
    1: 'gaotu',
    6: 'gongkao',
    2: 'tutu',
    8: 'jingpin',
    3: 'xinli',
    18: 'ketang',
}

export const APP_CONFIG_MAP: Record<AppName, IAppConfig> = {
    gaotu: {
        scheme: 'superclass',
        packageName: 'com.gaotu100.superclass',
        universalHost: 'www.gaotu.cn/jump',
        appstoreScheme: 'itms-apps://apps.apple.com/cn/app/1168617827',
        ckey: 'CK7195128947789177856',
        logo: gaotuLogoImg,
        cnName: '高途',
        bizType: 1,
        defaultUserName: '高途',
        defaultUserAvatar: defaultAvatarImg,
        // habo m站 业务名
        mHaboBizName: 'gt-m',
        // habo app 业务名
        appHaboBizName: 'gt-gaotu',
    },
    gongkao: {
        scheme: 'supergongkao',
        packageName: 'com.gaotu100.gongkao',
        universalHost: 'www.gaotu.cn/jump/6',
        appstoreScheme: 'itms-apps://apps.apple.com/cn/app/1632020721',
        logo: gongkaoLogoImg,
        cnName: '高途公考',
        bizType: 6,
        defaultUserName: '高途公考',
        defaultUserAvatar: defaultAvatarImg,
        mHaboBizName: 'gt-gongkao-m',
        appHaboBizName: 'gt-gongkao',
    },
    tutu: {
        scheme: 'supertutu',
        packageName: 'com.gaotu100.tutu',
        universalHost: 'www.gaotu100.com/jump',
        appstoreScheme: 'itms-apps://apps.apple.com/cn/app/1599225938',
        ckey: 'CK7195162598857943040',
        logo: tutuLogoImg,
        cnName: '途途课堂',
        bizType: 2,
        defaultUserName: '途途课堂',
        defaultUserAvatar: defaultAvatarTutuImg,
        mHaboBizName: 'tutu-m',
        appHaboBizName: 'tutu-app',
    },
    jingpin: {
        scheme: 'superjingpin',
        packageName: 'com.gaotu100.jingpin',
        // 精品(高中)没有pc官网跳不了app
        // universalHost: '',
        universalHost: 'www.gtgz.cn/jump',
        appstoreScheme: 'itms-apps://apps.apple.com/cn/app/1632885855',
        ckey: 'CK7195146975914402816',
        logo: jingpinLogoImg,
        cnName: '高途高中规划',
        bizType: 8,
        defaultUserName: '高途高中规划',
        defaultUserAvatar: defaultAvatarImg,
        mHaboBizName: 'gt-jingpin-m',
        appHaboBizName: 'gt-jingpin',

    },
    xinli: {
        scheme: 'superxinli',
        packageName: 'com.gaotu100.xinli',
        universalHost: 'www.gaotu.cn/jump/3',
        appstoreScheme: 'itms-apps://apps.apple.com/cn/app/6446154871',
        ckey: 'CK7215756754307186688',
        logo: xinliLogoImg,
        cnName: '高途心理',
        bizType: 3,
        defaultUserName: '高途心理',
        defaultUserAvatar: defaultAvatarImg,
        mHaboBizName: 'gt-c-xinli',
        appHaboBizName: 'gt-c-xinli',
    },
    ketang: {
        scheme: 'superketang',
        packageName: 'com.gaotu100.ketang',
        universalHost: 'www.naiyouxuexi.com/jump',
        appstoreScheme: 'itms-apps://itunes.apple.com/cn/app/id6476976133',
        cnName: '高途素养',
        bizType: 18,
        logo: ketangLogoImg,
        defaultUserName: '高途素养',
        defaultUserAvatar: defaultAvatarImg,
        mHaboBizName: 'tutu-gtketang-wap',
        appHaboBizName: 'tutu-gtketang-wap',
    },
}

let hasInit = false

/**
 * @description: 初始化打开app sdk
 */
const initOpenAppSDK = (propAppName?: AppName, inAppInit?: boolean) => {
    if (IS_SERVER) {
        return
    }
    const {appName, isApp} = getUaParam()
    if (!inAppInit && (isApp || hasInit)) {
        return
    }
    const {
        scheme,
        packageName,
        universalHost,
        fallback,
        appstore,
        ckey,
    } = APP_CONFIG_MAP[propAppName || appName || 'gaotu']
    const downloadUrl = `http://a.app.qq.com/o/simple.jsp?pkgname=${packageName}&ckey=${ckey}&ios_scheme=${scheme}%3A%2F%2Fjump%3Fcategory%3Dnative%26action_type%3Dlogin%3A%2F%2Fopen`

    require('@gaotu/open-app-sdk').initConfig({
        // 初始化 open-app-sdk
        scheme,
        packageName,
        universalHost,
        appid: appName === 'gaotu' ? 'wx6755c78557f70009' : '', // 目前高途 App 才有微信开放标签
        // ios唤起app失败跳转地址
        appstore: appstore || downloadUrl,
        // 安卓唤起app失败跳转地址
        fallback: fallback || downloadUrl,
        timeout: 3000, // 超时时间, 3000 内页面未隐藏认为唤起失败, 安卓会跳转上面 fallback 链接, ios 会跳转 appstore 链接
        wechatFailPathname: '',
    })
    hasInit = true
}

export default initOpenAppSDK
